'use client'

import React from 'react'
import { Box, Fade, styled } from '@mui/material'
import ProposalDetails from '@containers/dao/components/ProposalDetails'

const RootLayout = styled(Box)(() => ({
  minHeight: '100dvh',
  maxWidth: '100dvw',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  top: 100,
}))

const ProposalDetailsPage = ({
  params,
}: {
  params: { proposalKey: string }
}) => {
  return (
    <Fade in>
      <RootLayout>
        <ProposalDetails proposalKey={params.proposalKey} />
      </RootLayout>
    </Fade>
  )
}

export default ProposalDetailsPage
